import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { fetchCategory, fetchStates } from "../redux/Slice";
import Style from "../style/newheader.module.scss";
import Overlay from "./Overlay";

const NewHeader = () => {
  const dispatch = useAppDispatch();
  const { stateData, categoryData } = useAppSelector((state) => state.detail);
  const [overlay, setOverlay] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [line, setLine] = useState(0);
  const [mobileSearch, setMobileSearch] = useState(false);
  const [data, setData] = useState({ location: "", category: "" });
  const [selectedCityName, setSelectedCityName] = useState<string | null>(null);
  const [showDropdown, setShowDropdown] = useState({
    location: false,
    category: false,
  });

  useEffect(() => {
    if (!stateData) dispatch(fetchStates());
    if (!categoryData) dispatch(fetchCategory());
  }, [dispatch, stateData, categoryData]);

  useEffect(() => {
    const handleLine = () => {
      const scrolled = window.scrollY;
      const lineHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setLine((scrolled / lineHeight) * 100);
    };
    window.addEventListener("scroll", handleLine);
    return () => {
      window.removeEventListener("scroll", handleLine);
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setShowDropdown((prev) => ({ ...prev, [name]: value.trim() !== "" }));
  };

  const handleSelectCity = (cityName: string) => {
    setData((prev) => ({ ...prev, location: cityName }));
    setSelectedCityName(cityName);
    setShowDropdown((prev) => ({ ...prev, location: false }));
  };

  const handleSelectCategory = (categoryName: string) => {
    setData((prev) => ({ ...prev, category: categoryName }));
    setShowDropdown((prev) => ({ ...prev, category: false }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const { location, category } = data;

    if (!location && !category) {
      alert("Please enter at least one input before searching.");
      return;
    }

    if (location && !category) {
      window.location.pathname = `/listing/city/${selectedCityName
        ?.toLowerCase()
        .replaceAll(" ", "-")}`;
    } else if (!location && category) {
      window.location.pathname = `/listing/category/${category
        .toLowerCase()
        .replaceAll(" ", "-")}`;
    } else if (location && category) {
      window.location.pathname = `/listing/${category
        .toLowerCase()
        .replaceAll(" ", "-")}/${selectedCityName
        ?.toLowerCase()
        .replaceAll(" ", "-")}`;
    }
  };

  const filteredCities =
    stateData?.states
      ?.flatMap((state) => state.cities)
      ?.filter((city) =>
        city.name
          .toLowerCase()
          .replaceAll(" ", "-")
          .includes(data.location.toLowerCase().replaceAll(" ", "-"))
      ) || [];

  const filteredCategories =
    categoryData?.categories?.filter((category) =>
      category.name
        .toLowerCase()
        .replaceAll(" ", "-")
        .includes(data.category.toLowerCase().replaceAll(" ", "-"))
    ) || [];

  const handleNav = () => {
    setShowNav(true);
    setOverlay(true);
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  };

  const handleOverlay = () => {
    setShowNav(false);
    setOverlay(false);
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  const handleSearch = () => {
    setMobileSearch(!mobileSearch);
  };

  return (
    <div className={Style.container}>
      <>{overlay && <Overlay />}</>
      <div className={Style.wrapper}>
        <div className={Style.header}>
          <div className={Style.leftSection}>
            <div className={Style.Icon}>
              <h2 onClick={handleNav}>☰</h2>
              <div className={`${Style.navbar} ${showNav ? Style.show : ""}`}>
                <h2>
                  Menu<span onClick={handleOverlay}>X</span>
                </h2>
                <ul>
                  <li>
                    <a href="/">
                      {" "}
                      <i className="fa-solid fa-house"></i>Home
                    </a>
                  </li>
                  <li>
                    <a href="/about-us">
                      {" "}
                      <i className="fa-solid fa-user"></i>About us
                    </a>
                  </li>
                  <li>
                    <a href="/listing">
                      <i className="fa-solid fa-rectangle-list"></i>Listing
                    </a>
                  </li>
                  <li>
                    <a href="/contact">
                      {" "}
                      <i className="fa-solid fa-address-card"></i>Contact
                    </a>
                  </li>
                  <li>
                    <a href="/blog">
                      {" "}
                      <i className="fa-solid fa-blog"></i>Blog
                    </a>
                  </li>
                  <li>
                    <a href="/dashboard/new">
                      <img
                        src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/nav_listing_icon.svg"
                        alt="Listing"
                        loading="lazy"
                      />
                      Free Listing
                    </a>
                  </li>
                  <li>
                    <a href="/register">
                      <i className="fa-solid fa-user-tie"></i>
                      SignUp <span>/</span>
                      <a href="/login">Login</a>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className={Style.logo}>
              <a href="/">One Dial USA</a>
            </div>
          </div>
          <div className={Style.rightSection}>
            <div className={Style.searchIcon} onClick={handleSearch}>
              <i
                className={`fa-solid fa-magnifying-glass ${
                  mobileSearch ? Style.hide : Style.show
                }`}
              ></i>
              <h2 className={mobileSearch ? Style.show : Style.hide}>X</h2>
            </div>
            <div className={Style.seachBox}>
              <form onSubmit={handleSubmit}>
                <div className={Style.box}>
                  <i className="fa-solid fa-location-dot"></i>
                  <input
                    type="text"
                    placeholder="Enter Location"
                    name="location"
                    value={data.location}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {showDropdown.location && filteredCities.length > 0 && (
                    <div className={Style.dropdown}>
                      <ul>
                        {filteredCities.map((city) => (
                          <li
                            key={city.id}
                            onClick={() => handleSelectCity(city.name)}
                          >
                            {city.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className={Style.box}>
                  <i className="fa-solid fa-briefcase"></i>
                  <input
                    type="text"
                    placeholder="Business Category"
                    name="category"
                    value={data.category}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {showDropdown.category && filteredCategories.length > 0 && (
                    <div className={Style.dropdown}>
                      <ul>
                        {filteredCategories.map((category) => (
                          <li
                            key={category.id}
                            onClick={() => handleSelectCategory(category.name)}
                          >
                            {category.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <button type="submit">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </form>
            </div>
            <div
              className={`${Style.searchBox} ${
                mobileSearch ? Style.active : ""
              }`}
            >
              <div className={Style.mobileBox}>
                <form onSubmit={handleSubmit}>
                  <div className={Style.box}>
                    <i className="fa-solid fa-location-dot"></i>
                    <input
                      type="text"
                      placeholder="Enter Location"
                      name="location"
                      value={data.location}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {showDropdown.location && filteredCities.length > 0 && (
                      <div className={Style.dropdown}>
                        <ul>
                          {filteredCities.map((city) => (
                            <li
                              key={city.id}
                              onClick={() => handleSelectCity(city.name)}
                            >
                              {city.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className={Style.box}>
                    <i className="fa-solid fa-briefcase"></i>
                    <input
                      type="text"
                      placeholder="Business Category"
                      name="category"
                      value={data.category}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {showDropdown.category && filteredCategories.length > 0 && (
                      <div className={Style.dropdown}>
                        <ul>
                          {filteredCategories.map((category) => (
                            <li
                              key={category.id}
                              onClick={() =>
                                handleSelectCategory(category.name)
                              }
                            >
                              {category.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  <button type="submit">Search</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={Style.borderLine} style={{ width: `${line}%` }}></div>
    </div>
  );
};

export default NewHeader;
